
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {
    Paginator: () => import("@/components/Paginator.vue"),
    SortColumn: () => import("@/components/SortColumn.vue"),
    Modal: () => import("@/components/Modal.vue"),
  },
  computed: {
    years() {
      let years: any = [];
      for (let i: number = new Date().getFullYear(); i >= 2000; i--) {
        years.push(i);
      }
      return years;
    },
  },
  filters: {
    date(value) {
      return value ? moment(value, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
    },
    formatMoney(val) {
      if (!val) return "";
      return String(val).formatMoney();
    },
  },
  watch: {
    $route(to, from) {
      (this as any).init();
    },
  },
})
export default class ClaimsPayments extends Vue {
  adminRoles: any = [];
  dictionary: any = {};
  title: string = "";
  filter: any = {
    businessId: "",
    companyId: "",
    month: "",
    year: "",
    branchId: "",
    trimester: "",
    status: -1,
    requestNumber: "",
    claimCode: "",
    claimNumber: "",
    modifyType: -1,
  };
  currentClaim: number = 0;
  claimspayments: any = [];
  businesses: any = [];
  companies: any = [];
  controlzones: any = [];
  branches: any = [];
  months: any = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Augosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];
  statuses: any = [];
  trimesters: any = [];
  limit: number = 5;
  totalRows: number = 0;
  sortColumns: Record<string, string> = {
    name: "Contrato",
    owner: "Responsable",
    deletedAt: "Estado",
  };
  currentSort: Record<string, string> = {
    col: "status",
    dir: "asc",
  };

  async mounted() {
    await this.loadDictionary();
    await this.loadCompanies();
    await this.loadBranches();
    await this.loadBusinesses();
    await this.init();
  }

  async init() {
    this.filter.modifyType = -1;
    this.title = "Procesar Pagos";
    this.loadControlZones();
    this.loadTrimesters();
    this.loadStatuses();
    this.loadPayments(1, this.currentSort);
  }

  showDeleteModal(id: number) {
    this.currentClaim = id;
    (this.$refs.modal as any).show();
  }

  async deleteRequest() {
    try {
      let response: any = await (this.$root as any)._delete(
        `claimspayments/${this.currentClaim}`
      );
      this.loadPayments(1, this.currentSort);
      (this.$refs.modal as any).hide();
      (this.$root as any).notify("Se elimino el siniestro con éxito.");
    } catch (e) {
      (this.$root as any).notify("No se pudo eliminar el siniestro.", "error");
    }
  }

  clearFilters() {
    Object.keys(this.filter).forEach((key: any) => {
      if (key === "modifyType") this.filter[key] = -1;
      else this.filter[key] = "";
    });
    this.loadPayments(1, this.currentSort);
  }

  statusClass(status) {
    switch (status) {
      case 0:
        return "pending";
      case 1:
        return "active";
      case 2:
      default:
        return "inactive";
    }
  }

  onPageChange(page: number, limit: number) {
    this.limit = limit;
    this.loadPayments(page, this.currentSort);
  }

  // async loadAdminRoles() {
  //   const response: any = await (this.$root as any)._get("admins/getroles");
  //   this.adminRoles = response;
  // }

  async loadPayments(page: number, sort: Record<string, string>) {
    // TODO: DEPRECATED -> DELETE AFTER TESTING
    //
    // let companyIds = [];
    // await this.loadAdminRoles();
    // if (this.$store.state.user.type == this.adminRoles.REASEGURADOR) {
    //   const companies: any = await (this.$root as any)._post("companies/all", {
    //     adminId: this.$store.state.user.id
    //   });
    //   companies.data.forEach(company => {
    //     companyIds.push(company.id);
    //   });
    // }

    // if (companyIds.length > 0) {
    //   this.filter.companyIds = companyIds.join(",");
    // }

    this.currentSort = sort;

    const response: any = await (this.$root as any)._post(
      "claimspayments/all",
      {
        limit: this.limit,
        page: page,
        order: this.currentSort,
        ...this.filter,
      }
    );
    this.totalRows = response.totalRows;
    this.claimspayments = response.data;
  }

  async loadDictionary() {
    const response: any = await (this.$root as any)._get("requests/dictionary");
    this.dictionary = response;
  }

  async loadBusinesses() {
    const response: any = await (this.$root as any)._post("businesses/all");
    this.businesses = response.data;
  }

  async loadCompanies() {
    const response: any = await (this.$root as any)._post("companies/all");
    this.companies = response.data;
  }

  async loadControlZones() {
    const response: any = await (this.$root as any)._post("controlzones/all");
    this.controlzones = response.data;
  }

  async loadBranches() {
    const response: any = await (this.$root as any)._get("branches");
    this.branches = response.data;
  }

  async loadTrimesters() {
    const response: any = await (this.$root as any)._get(
      "claimspayments/trimesters"
    );
    this.trimesters = response;
  }

  async loadStatuses() {
    const response: any = await (this.$root as any)._get(
      "claimspayments/status"
    );
    this.statuses = response;
  }

  async exportPayments() {
    try {
      const response: any = await (this.$root as any)._post(
        "claimspayments/exportxls",
        {
          ...this.filter,
          totalpayments: false
        }
      );
      let result = await (this.$root as any)._getFile(response.path);
      let fileName = response.path.split('/').slice(-1);
      const url = window.URL.createObjectURL(new Blob([result]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute('download', fileName); //or any other extension
      document.body.appendChild(link);
      link.click();
      link.remove();
      /*window.open(response.path);*/
    } catch (e) {
      (this.$root as any).notify(
        "No se pudo exportar, intente más tarde.",
        "error"
      );
    }
  }
  async exportTotalPayments() {
    try {
      const response: any = await (this.$root as any)._post(
        "claimspayments/exportxls",
        {
          ...this.filter,
          totalpayments: true
        }
      );
      let result = await (this.$root as any)._getFile(response.path);
      let fileName = response.path.split('/').slice(-1);
      const url = window.URL.createObjectURL(new Blob([result]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute('download', fileName); //or any other extension
      document.body.appendChild(link);
      link.click();
      link.remove();
      /*window.open(response.path);*/
    } catch (e) {
      (this.$root as any).notify(
        "No se pudo exportar, intente más tarde.",
        "error"
      );
    }
  }
}
